import { render, staticRenderFns } from "./ContactFormFullDetails.vue?vue&type=template&id=72ae1006&"
import script from "./ContactFormFullDetails.vue?vue&type=script&lang=js&"
export * from "./ContactFormFullDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports